<script>
  export let scales = []
</script>

<div id="scales-list">
  {#each scales as scale, index}
    <div class="scale-view">
      <h4 class="index">[{index + 1}]</h4>
      <p>
        {#each scale as note}
          <span class="note-view">{note}  </span>
        {/each}
      </p>
    </div>
  {/each}
</div>

<style>
  #scales-list {
    display: flex;
    flex-wrap: wrap;
  }
  .scale-view {
    display: flex;
    justify-content: center;
    border: 1px solid grey;
    border-radius: 2px;
    margin: .3em;
    box-shadow: 5px 0 10px lightgrey;
    min-width: 16em;
    height: 4em;
    background-color: white;
  }
  .scale-view>p {
    margin: auto;
    width: 90%;
    display: flex;
    justify-content: space-evenly;
  }
  .index {
    margin-left: .5em;
  }
</style>